import React from 'react';
import LinkItem from '../../item/LinkItem';
import Collapse from '../../collapse/Collapse';

import PropTypes from 'prop-types';

class MenuDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentItem: 0,
    };
  }

  renderCollapseMenu = (menu, index) => (
    <Collapse title={menu.text} key={`menu-drawer-${index}`}>
      {menu.list.map((item, i) => (
        <LinkItem link={item.link} key={`menu-drawer-${index}-item-${i}`}>
          {item.text}
        </LinkItem>
      ))}
    </Collapse>
  );

  render() {
    const { list, title } = this.props;
    const { currentItem } = this.state;

    return (
      <div className='fui-menu-drawer'>
        <div className='fui-menu-drawer-head' id={`${this.props.id}-0`}>
          <div className='drawer-bar-left'>
            <div role='button' onClick={this.props.closeDrawer}>
              <i className='icon-chevron-left'></i>
            </div>
          </div>
          <div className='drawer-bar-center'>{title}</div>
          <div className='drawer-bar-right'>
            <div role='button' onClick={this.props.closeMenu}>
              <i className='icon-close'></i>
            </div>
          </div>
        </div>
        <div className='fui-menu-drawer-body'>
          <div className='fui-menu-drawer-sidemenu'>
            {list &&
              list !== null &&
              list.map((group, i) => (
                <div
                  id={`${this.props.id}-${i + 1}`}
                  key={`fui-menu-drawe-${i}`}
                  className={`fui-drawer-item ${currentItem === i ? 'is-active' : ''}`}
                  onClick={(e) => this.setState({ currentItem: i })}>
                  <img src={group.iconActive} alt={group.text} className={'icon is-active '} />
                  <img src={group.icon} alt={group.text} className={'icon '} />
                  <div className='text'>{group.text}</div>
                </div>
              ))}
          </div>
          {list &&
            list !== null &&
            list.map((group, i) => (
              <div
                id={`${this.props.id}-${i + 1}`}
                key={`fui-menu-drawer-content-${i}`}
                className={`fui-menu-drawer-container ${currentItem === i ? 'is-active' : ''}`}>
                {group.list !== null &&
                  group.list.map((item, j) =>
                    item.list ? (
                      this.renderCollapseMenu(item, j)
                    ) : (
                      <LinkItem key={`menu-drawer-${j}`} link={item.link}>
                        {item.text}
                      </LinkItem>
                    )
                  )}
              </div>
            ))}
        </div>
      </div>
    );
  }
}

MenuDrawer.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      icon: PropTypes.string,
      child: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
          link: PropTypes.string,
          child: PropTypes.arrayOf(
            PropTypes.shape({
              text: PropTypes.string,
              link: PropTypes.string,
            })
          ),
        })
      ),
    })
  ),
  closeDrawer: PropTypes.func,
  closeMenu: PropTypes.func,
};

export default MenuDrawer;
